/**
 */

define('directives/myservices/fingerPrint/fingerPrint.directives',['app','mainCons'], function (app,mainCons) {
    app.directive('fingerPrint', ['payService',function (payService) {
        var timeout;
        return {
            restrict: 'E',
            replace: true,
            require: "?ngModel",
            scope:{
                model:"=",
                packageForm:"="
            },
            templateUrl: '../refactor/directives/myservices/fingerPrint/fingerPrint.template.html',
            link: function ($scope, $element, attrs,ngModelCtrl) {
                $scope.showFingerPrintExam = payService.getFingerPrintExam;
                $scope.regexp = mainCons.servicesConstant.regexp;
                $scope.initData = getFingerPrintInfo;
                $scope.checkRepeat = checkRepeat;

                $scope.model.selected.oauthCertFingerprint = '';
                $scope.model.selected.oauthCertFingerprint1 = '';
                $scope.model.selected.oauthCertFingerprint2 = '';
                $scope.model.selected.oauthCertFingerprint3 = '';
                $scope.model.selected.oauthCertFingerprint4 = '';

                function checkParams(str, reg) {
                    if (str == '') {
                        return true;
                    }
                    //rpk 的sha256签名校验
                    if ($scope.model.selected.prodType == '19-1' || $scope.model.selected.prodType == '23' || $scope.model.selected.prodType == '28' || $scope.model.selected.prodType == '42'){
                        var regForRpk = $scope.regexp.oauthCertFingerprintForRpk;
                        return (new RegExp(regForRpk)).test(str) && str.length;
                    }else{//非rpk 的sha256签名校验
                        return (new RegExp(reg)).test(str);
                    }
                }

                function getFingerPrintInfo (){
                    payService.getFingerPrintInfo($scope.model.product.appInfo, $scope.model.selected);
                }


                $scope.$watch("model.selected.prodType",function(){
                    checkRepeat();
                    $scope.validOauthCertFingerprint=(function(){
                        return {
                            test:function(value){
                                return checkParams(value,$scope.regexp.oauthCertFingerprint);
                            }
                        }
                    })();
                });

                function checkRepeat(){
                    for (var n=0;n<5;n++){
                        var itemN = n==0? '': n;
                        if (!$scope.packageForm["oauthCertFingerprint"+itemN]) continue;
                        $scope.packageForm["oauthCertFingerprint"+itemN].$setValidity("repeat",true);
                    }
                    for (var i=0;i<5;i++){
                        var itemI = i==0? '': i;
                        for (var j= i+1;j<5;j++){
                            var itemJ = j==0? '': j;
                            if (!$scope.packageForm["oauthCertFingerprint"+itemI] || !$scope.packageForm["oauthCertFingerprint"+itemJ]) continue;
                            if ($scope.model.selected["oauthCertFingerprint"+itemI] && $scope.model.selected["oauthCertFingerprint"+itemI] == $scope.model.selected["oauthCertFingerprint"+itemJ]){
                                if (!$scope.packageForm["oauthCertFingerprint"+itemI].$error.pattern){
                                    $scope.packageForm["oauthCertFingerprint"+itemI].$setValidity("repeat",false);
                                }
                                if (!$scope.packageForm["oauthCertFingerprint"+itemJ].$error.pattern){
                                    $scope.packageForm["oauthCertFingerprint"+itemJ].$setValidity("repeat",false);
                                }
                            }
                        }
                    }

                }
            }
        }
    }]);
});

